// extracted by mini-css-extract-plugin
export default {"NewButton":"DragDrop_NewButton__J6eIe","Drag":"DragDrop_Drag__ssWoC","Select":"DragDrop_Select__TlrnR","BGColor":"DragDrop_BGColor__GsYcm"};